/**
 * @file: ServiceEvaluate.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 服务评价管理
 */
import request from '@/utils/request'

/**
 * 新增服务评价
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluateAdd(data) {
  return request({
    type: 'biz',
    url: 'evaluate/add',
    method: 'post',
    data
  })
}

/**
 * 删除服务评价管理
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluateDelete(data) {
  return request({
    type: 'biz',
    url: 'evaluate/delete',
    method: 'post',
    data
  })
}

/**
 * 获取服务评价管理详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluateGet(data) {
  return request({
    type: 'biz',
    url: 'evaluate/get',
    method: 'post',
    data
  })
}

/**
 * 服务评价列表(分页)(pc端)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluatePageListGet(data) {
  return request({
    type: 'biz',
    url: 'evaluate/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改服务评价管理
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluateUpdate(data) {
  return request({
    type: 'biz',
    url: 'evaluate/update',
    method: 'post',
    data
  })
}

/**
 * 服务评价列表(分页)(微信端)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function evaluateWxPageListGet(data) {
  return request({
    type: 'biz',
    url: 'evaluate/wx/page/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ServiceEvaluate.js